const DEFAULT_TIMEZONE = 'local';

export function getTimezone() {
	return localStorage.getItem('timezone') || DEFAULT_TIMEZONE;
}

export function setTimezone(timezone) {
	localStorage.setItem('timezone', timezone);
}

function formatTime(date, timezone = getTimezone(), type = 'full') {
	const options = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: false
	};

	let timeZone;
	switch (timezone) {
		case 'moscow':
			timeZone = 'Europe/Moscow';
			break;
		case 'london':
			timeZone = 'Europe/London';
			break;
		case 'local':
		default:
			timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			break;
	}

	const formatOptions =
		type === 'date'
			? { year: 'numeric', month: '2-digit', day: '2-digit' }
			: type === 'time'
				? { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }
				: options;

	return new Intl.DateTimeFormat('ru-RU', { ...formatOptions, timeZone }).format(date);
}

const OriginalDate = window.Date;

export class CustomDate extends OriginalDate {
	constructor(...args) {
		super(...args);
	}

	toString() {
		return formatTime(this, getTimezone());
	}

	toLocaleString(locale, options) {
		const timezone = getTimezone();
		if (timezone === 'local') {
			return super.toLocaleString(locale, options);
		}
		return formatTime(this, timezone);
	}

	toLocaleDateString(locale, options) {
		const timezone = getTimezone();
		if (timezone === 'local') {
			return super.toLocaleDateString(locale, options);
		}
		return formatTime(this, timezone, "date");
	}

	toLocaleTimeString(locale, options) {
		const timezone = getTimezone();
		if (timezone === 'local') {
			return super.toLocaleTimeString(locale, options);
		}
		return formatTime(this, timezone, "time");
	}
}


window.Date = CustomDate;